import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/denim-glasses/page.client.tsx");
